import { useTranslation } from "react-i18next";

import { ReactComponent as NoDevicesImage } from "../../../../../../assets/images/no-devices.svg";
import { InfiniteTable } from "../../../../../../components/InfiniteTable";
import { Table } from "../../../../../../components/Table";
import { TableSkeleton } from "../../../../../../components/TableSkeleton";
import { ImageContainer } from "../../../PatientNotesTable/PatientNotesTable.style";
import {
  DevicesTableContainer,
  DevicesTableInnerContainer,
  NoContentMessage,
} from "./DevicesTable.style";
import { devicesTableColumns } from "./tableColumns";

interface IDvicesTableProps {
  content?: any;
  isLoading?: boolean;
  // Infinite scroll props (optional for backward compatibility)
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  fetchNextPage?: () => void;
  useInfiniteScroll?: boolean;
}

export function DevicesTable({
  content,
  isLoading = false,
  hasNextPage = false,
  isFetchingNextPage = false,
  fetchNextPage,
  useInfiniteScroll = false,
}: IDvicesTableProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <DevicesTableContainer style={{ overflow: "hidden" }}>
        <DevicesTableInnerContainer style={{ overflow: "hidden" }}>
          <TableSkeleton columnsNumber={6} rowsNumber={6} />
        </DevicesTableInnerContainer>
      </DevicesTableContainer>
    );
  }

  if (content && content.length > 0) {
    // Use InfiniteTable when infinite scroll is enabled
    if (useInfiniteScroll && fetchNextPage) {
      return (
        <DevicesTableContainer>
          <DevicesTableInnerContainer>
            <InfiniteTable
              rowPadding
              data={content}
              emptyStateText={t("patientPage_devices_noData")}
              columns={devicesTableColumns}
              hasNextPage={hasNextPage}
              isFetchingNextPage={isFetchingNextPage}
              fetchNextPage={fetchNextPage}
              skeletonColumns={6}
              skeletonRows={6}
            />
          </DevicesTableInnerContainer>
        </DevicesTableContainer>
      );
    }

    // Default to regular Table for backward compatibility
    return (
      <DevicesTableContainer>
        <DevicesTableInnerContainer>
          <Table
            rowPadding
            data={content}
            emptyStateText={t("patientPage_devices_noData")}
            columns={devicesTableColumns}
          />
        </DevicesTableInnerContainer>
      </DevicesTableContainer>
    );
  }

  return (
    <ImageContainer>
      <NoDevicesImage width={181} height={158} />
      <NoContentMessage>{t("patientPage_devices_empty")}</NoContentMessage>
    </ImageContainer>
  );
}
